<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
<!--          <b-breadcrumb :items="breadcrumbs"/>       
 -->        <b-card>
          <div slot="header">
            <strong> Rack Management</strong>
            <div class="card-header-actions" >                
              <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="rackadd()"  type="button">Add New Rack</button>
               <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button>
            </div>
          </div>

         
          <div id="addrack"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                <b-row> 
                  <b-col sm="4">
                    <div class="form-group row">
                       <label class="col-md-3 col-form-label" for="hf-email">Rack No</label>
                      <div class="col-md-9">
                        <b-form-input class="form-control" type="text" name="rackno" v-model="rackno" v-validate="'required|alpha_num|min:3|max:30'"placeholder="Enter Rack No" :class="{'input': true, 'text-danger': errors.has('form-1.rackno') }"  >
                       </b-form-input>
                       <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('rackno')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.rackno')" class="help text-danger">{{ errors.first('form-1.rackno') }}</span>
                      </b-input-group>
                      </div>
                    </div>                   
                  </b-col>
                
                  <b-col sm="3">
                    <b-button variant="primary" size="md" type="submit">Save</b-button>
                  </b-col>
                </b-row>  
              </b-form>
          </div>
            <b-row class="mb-4">          
                <b-col md="4" class="my-1">
                  <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                    <b-input-group>
                      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="4" class="my-1">
                  <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                    <b-input-group>
                      <b-form-select v-model="sortBy" :options="sortOptions">
                        <option slot="first" :value="null">-- none --</option>
                      </b-form-select>
                      <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                        <option :value="false">Asc</option> <option :value="true">Desc</option>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>             
                <b-col md="4" class="my-1">
                  <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>            
            </b-row>  
               <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col>  
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  

        
          </b-table>

          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>    
        </b-card>
       
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'rack', 
  data: function() {
    return {
      name: 'rack',
      isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'Rack Management',
        active: true
      }],
      add: true,
      rackno:'',           
      items:[],
     fields: [
          { key: 'id', label: 'id', sortable: true, sortDirection: 'desc' },
          { key: 'rackno', label: 'Rack No', sortable: true},
          { key: 'shipment_id', label: 'Shipment Id', sortable: true,tdClass: 'nameOfTheClass'}
        
       ], 
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'desc',
        filter: null,
        currenthubidselct:'',
    }
  },
  created: function() {  
    this.displaydata();
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.currenthubidselct=userInfo.pickuplocationmasterid.toString();
  },
  computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  methods: {
     
    validateForm(scope) {
       this.$validator.validateAll(scope).then(result => {
        if (result) {          
          this.addRackInfo();
        }
      });
    },
    clear1: function() {},
    rackadd: function() {
      this.errors.clear("form-1");
   
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addrack = document.getElementById("addrack");
      addrack.style.display = "block";
    
    },
    refresh:function() {
     
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addrack = document.getElementById("addrack");
      addrack.style.display = "none";
      this.clear();
    },
   
    chkrackVal: function() {
        var length = this.items.length;       
        var needle =this.rackno.toLowerCase();
        for(var i = 0; i < length; i++) {
           // console.log(this.items[i].rackno +' '+needle);
            if(this.items[i].rackno.toLowerCase() == needle)
            { 
              return true;
            }
        }
        return false;
    },
    displaydata: function () {
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.currenthubidselct=userInfo.pickuplocationmasterid.toString();

       const rackinfo = {
        hubid: `${this.currenthubidselct}`,      
      }
      this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster/getRackList`,rackinfo)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             this.items  = result.body.returnvalue;
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            this.items=[];
            this.totalRows =0;
               this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    addRackInfo: function() {
      var chkrackVal = this.chkrackVal();

      if (chkrackVal==false) {

        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.currenthubidselct=userInfo.pickuplocationmasterid.toString();  
        this.$validator.validateAll().then(result => {         
          if (result) {
             const rackinfosave = {
                hubid: `${this.currenthubidselct}`,
                status: 0,
                rackno: `${this.rackno.toLowerCase().trim()}`,      
              }
              // console.log(rackinfosave);
            this.$http
              .post(
                `${
                  CONSTANTS.API_URL
                }/DeliveryAgentMaster/RackMasterAdd`,
                rackinfosave
              )
              .then(result => {               
                if (result.body.returnmsg === "Successful") {
                 Utils.notify("Added successfully", "success");
                 var addrack = document.getElementById("addrack");
                  addrack.style.display = "none";
                  this.clear();
                  this.displaydata();
                  this.$router.push('/rack');
                } else {
                  if (result.body.returnmsg === "unsuccessful") {
                    Utils.notify(result.body[0].returnvalue, "error");
                  } else if (result.body[0].returnvalue === "0") {
                    Utils.notify(result.body[0].returnmsg, "error");
                  } else {
                    Utils.notify(result.body[0].returnmsg, "error");
                  }
                }
                 this.$router.push('/rack');
              })
              .catch(ex => {
                console.log("error", ex);
              });
          } else {
            Utils.notify("Correct them errors", "error");
          }
        });
      } else {
        Utils.notify("This number is already exist", "error");
      }
    },
     
    clear: function() {
      this.rackno = '';
      this.errors.clear('form-1')    
    }    
    
  }
 
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .nameOfTheClass {
   max-width: 450px;
}
</style>
